import { storage } from './authStorage';
import { pb } from './pb';

const DEBUG = (process.env.EXPO_PUBLIC_DEBUG_LOGS || '').toString() === '1';
const dlog = (...args: any[]) => { if (DEBUG) console.log(...args); };

const AUTH_KEY = 'pb_auth';
const CREDS_KEY = 'pb_creds';

export async function restoreAuth() {
  dlog('[auth] restoreAuth start');
  const raw = await storage.getItem(AUTH_KEY);
  if (raw) {
    const { token, model } = JSON.parse(raw);
    dlog('[auth] restored token?', Boolean(token), 'model?', Boolean(model));
    if (token) pb.authStore.save(token, model);
  }
}

pb.authStore.onChange(async (token, model) => {
  dlog('[auth] authStore change. valid=', pb.authStore.isValid);
  if (token) await storage.setItem(AUTH_KEY, JSON.stringify({ token, model }));
  else await storage.deleteItem(AUTH_KEY);
});

export async function login(identity: string, password: string): Promise<string | null> {
  dlog('[auth] login with identity=', identity);
  const authData = await pb.collection('devices').authWithPassword(identity, password);
  let deviceId: string | undefined = (authData as any)?.record?.id;
  if (!deviceId) {
    // Give authStore a tick to update, then check again
    await new Promise((r) => setTimeout(r, 0));
    deviceId = (pb.authStore as any)?.model?.id as string | undefined;
  }
  dlog('[auth] login success, deviceId=', deviceId);
  await storage.setItem(CREDS_KEY, JSON.stringify({ identity, password }));
  return deviceId ?? null;
}

export async function loginUser(identity: string, password: string): Promise<string | null> {
  dlog('[auth] loginUser with identity=', identity);
  const authData = await pb.collection('users').authWithPassword(identity, password);
  let userId: string | undefined = (authData as any)?.record?.id;
  if (!userId) {
    await new Promise((r) => setTimeout(r, 0));
    userId = (pb.authStore as any)?.model?.id as string | undefined;
  }
  dlog('[auth] loginUser success, userId=', userId);
  return userId ?? null;
}

export async function reloginIfNeeded() {
  dlog('[auth] reloginIfNeeded valid=', pb.authStore.isValid);
  if (pb.authStore.isValid) return;
  const raw = await storage.getItem(CREDS_KEY);
  dlog('[auth] creds present?', Boolean(raw));
  if (!raw) return;
  const { identity, password } = JSON.parse(raw);
  dlog('[auth] relogin as', identity);
  await pb.collection('devices').authWithPassword(identity, password);
}

let refreshInFlight: Promise<void> | null = null;

export async function refreshAuth() {
  if (refreshInFlight) return refreshInFlight;
  refreshInFlight = (async () => {
    dlog('[auth] refreshAuth valid=', pb.authStore.isValid);
    try {
      if (pb.authStore.isValid) {
        const model: any = pb.authStore.model as any;
        const collection = model?.collectionName;
        if (collection === 'users') {
          await pb.collection('users').authRefresh();
        } else {
          await pb.collection('devices').authRefresh();
        }
      } else {
        // Attempt silent re-login using saved device credentials (if present)
        await reloginIfNeeded();
      }
    } catch {}
  })();
  try {
    await refreshInFlight;
  } finally {
    refreshInFlight = null;
  }
}

export async function logout() {
  try {
    await storage.deleteItem(AUTH_KEY);
    await storage.deleteItem(CREDS_KEY);
  } catch {}
  pb.authStore.clear();
}
